import Tab from 'react/containers/layout/tabs/Tab';
import PropTypes from 'prop-types';

const brokenLinkIconUrl = require("static/images/broken-link.svg");

class AccessDenied extends Tab {

  static propTypes = {
    active: PropTypes.bool,
    tab: PropTypes.object,
    updateTitle: PropTypes.func
  }

  componentDidMount() {
    const { updateTitle, tab: { key } } = this.props;
    updateTitle({
      key,
      title: Monet.I18n.getResourcesByKey('AccessDenied.error')
    });
  }

  activeClassName = 'is-active'

  render() {
    const { active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;
    return (
      <div className={className}>
        <div id='AccessDenied'>
          <div id='errorContainer'>
            <img id='brokenLinkIcon' src={ brokenLinkIconUrl }></img>
            <div id='errorTitle'>
              { Monet.I18n.getResourcesByKey('AccessDenied.errorTitle') }
            </div>
            <div id='errorDescription'>
              { Monet.I18n.getResourcesByKey('AccessDenied.errorDescription') }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default AccessDenied;
